export const apiUrl = config.apiUrl;
export const clientUrl = config.clientUrl;
export const storageStateVersion = '49';
export const storageCacheVersion = '8';
export const env = config.env;

export const googleAnalyticsDebug = false;
export const googleAnalyticsId = 'G-8EZDVETVDM';
export const logRocketDsn = config.logRocketDsn;

export const orgsExcludeFromAllOrgsAnalytics = config.orgsExcludeFromAllOrgsAnalytics;

export const makeOrganizationEmailDomain = '@make.services';

// Staff accounts outside the MAKE org that are allowed to see the AI Chats / AI Feedback insights
export const aiInsightsAllowedEmails = [
    'sunbo@uw.edu',
    'nbe4@u.washington.edu',
    'sunbo@u.washington.edu',
    'nbe4@uw.edu',
];

export const globalLocationId = 1;
export const chinaLocationId = 6;
export const australiaLocationId = 71;
export const newZealandLocationId = 72;
export const southeastAsiaEastAsiaAndOceaniaLocationId = 4;
export const oceaniaLocationId = 21;

// list of countries to fix empty data issues on global map
export const globalMapCountryLocationsIds =
    '6,7,8,10,11,12,13,14,15,16,17,18,19,20,22,23,24,25,26,27,28,29,30,33,34,35,36,37,38,39,40,41,43,44,45,46,47,48,49,50,51,52,53,54,55,57,58,59,60,61,62,63,66,67,68,69,71,72,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,97,98,99,101,102,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,121,122,123,125,126,127,128,129,130,131,132,133,135,136,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,160,161,162,163,164,165,168,169,170,171,172,173,175,176,177,178,179,180,181,182,183,184,185,186,187,189,190,191,193,194,195,196,197,198,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,298,305,349,351,376,385,422,435,522';
